import RequiredUserPlan from './RequiredUserPlan';

export default RequiredUserPlan;
